import axios from 'axios'

import injectHeaders from './axios/on-request-inject-headers.js'
import setBaseUrl from './axios/on-request-set-base-url.js'
import validateUnauthorized from './axios/on-response-validate-unauthorized.js'
import onNetworkError from './axios/on-network-error.js'
import unexpectedError from './axios/on-response-validate-unexpected-error.js'
import validateRefreshToken from './axios/on-response-validate-refresh-token.js'

export default function setup() {
  axios.interceptors.request.use(config =>
    Object.assign(config, setBaseUrl(config), injectHeaders(config))
  )

  axios.interceptors.response.use(
    response =>
      Promise.resolve(Object.assign(response, validateRefreshToken(response))),

    error =>
      Promise.reject(
        Object.assign(
          error,
          onNetworkError(error),
          validateUnauthorized(error),
          unexpectedError(error)
        )
      )
  )
}
